import React, { useCallback, useEffect } from 'react';
import { useMemo } from 'react';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Header from '../../components/Header';
import StandardContainer from '../../components/StandardContainer';
import TableEditorial from '../../components/Table';
import { useToast } from '../../hooks/toast';
import api from '../../services/api';
import { Content } from './styles';

import TableCell from '@material-ui/core/TableCell';
import Checkbox from '@material-ui/core/Checkbox';

interface Data {
  id: string;
  code: number;
  name: string;
  color: string;
}

interface IEditorial {
  id: number;
  name: string;
  color: string;
}

function createData(
  id: string,
  code: number,
  name: string,
  color: string,
): Data {
  return { id, code, name, color };
}

interface HeadCell {
  disablePadding: boolean;
  id: keyof Data;
  label: string;
  numeric: boolean;
}

const headCells: HeadCell[] = [
  { id: 'code', numeric: true, disablePadding: true, label: 'ID' },
  { id: 'name', numeric: false, disablePadding: false, label: 'Nome' },
  { id: 'color', numeric: false, disablePadding: false, label: 'Cor' },
];

const Editorial = () => {
  const [rows, setRows] = useState<IEditorial[]>([]);
  const [deleted, setDeleted] = useState(false);
  const [loading, setLoading] = useState(true)

  const { addToast } = useToast();

  const history = useHistory();

  useEffect(() => {
    api.get('/editorials/').then(response => {
      setRows(response.data);
      setLoading(false);
    });
  }, [deleted]);

  const onDelete = useCallback((id) => {
    api.delete(`/editorials/${id}`).then(response => {
      setDeleted(!deleted);
      addToast({
        type: 'success',
        title: 'Editoria deletada com sucesso!',
      });
    });
  }, [setDeleted, deleted, addToast])

  const editorialRows = useMemo(() => {
    return rows.map(row => createData(row.id.toString(), row.id, row.name, row.color));
  }, [rows]);

  const onCreate = useCallback(() => {
    history.push('/editorial/new');
  }, [history]);

  const onEdit = useCallback((row) => {
    history.push('/editorial/edit', { id: row.code });
  }, [history]);

  const tableBodyCells = useCallback((isItemSelected, labelId, row) => (
    <>
      <TableCell padding="checkbox">
          <Checkbox
            checked={isItemSelected}
            inputProps={{ 'aria-labelledby': labelId }}
          />
      </TableCell>
      <TableCell component="th" id={labelId} scope="row" padding="none">
        {row.id}
      </TableCell>
      <TableCell align="left">{row.name}</TableCell>
      <TableCell align="left"><div style={{ color: `${row.color}`, fontWeight: 'bold' }}>{row.color}</div></TableCell>
    </>
  ), []);

  return (
    <StandardContainer>
      <Header />
      <Content>
        <TableEditorial<Data, HeadCell[]>
          title='Editoria'
          headCells={headCells}
          rows={editorialRows}
          orderByDefaultColumn='code'
          onCreate={onCreate}
          onDelete={onDelete}
          onEdit={onEdit}
          tableBodyCells={tableBodyCells}
          loading={loading}
        />
      </Content>
    </StandardContainer>
  )
}

export default Editorial;
